//import '../css/app.css';
import ElementPlus from "element-plus";

import { createInertiaApp } from "@inertiajs/vue3";

import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createPinia } from "pinia";
import { createApp, h } from "vue";
import { ZiggyVue } from "ziggy-js";

const appName = import.meta.env.VITE_APP_NAME || "Laravel";

createInertiaApp({
	title: (title) => (title ? `${title} - ${appName}` : appName),
	resolve: (name) => resolvePageComponent(`./pages/${name}.vue`, import.meta.glob("./pages/**/*.vue")),
	setup({ el, App, props, plugin }) {
		const pinia = createPinia();

		createApp({ render: () => h(App, props) })
			.use(plugin)
			.use(pinia)
			.use(ElementPlus)
			.use(ZiggyVue)
			.mount(el);
	},
	progress: {
		color: "#4B5563",
	},
});
